import constants from "../../../../../appConstants";
import {
  mergeUserConfig,
  formatDateTimeWithoutUTCConversion,
} from "../../../../dataGrid/gridUtilities";
import {
  MultiSelectFilter,
  DateTimeFilter,
} from "../../../../dataGrid/columnFilters";
import { isDispatched } from "../utils/DispatchStatus";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration(userConfig) {
    const defaultConfig = GridConfig.getDefaultConfiguration();
    return mergeUserConfig({
      defaultConfig,
      userConfig,
    });
  }

  static TrailerNumberRenderer = (params) => {
    if (!params.data.trailerNumber) {
      return <span style={{ opacity: 0.5 }}>No trailer</span>;
    }
    return <span>{params.data.trailerNumber}</span>;
  };

  static ManifestNumberRenderer = (params) => {
    if (!params.data.manifestNumber) {
      return <span style={{ opacity: 0.5 }}>No Manifest</span>;
    }
    return <span>{params.data.manifestNumber}</span>;
  };

  static isEditable = (params) => {
    return !isDispatched(params);
  };

  static getDefaultConfiguration() {
    return {
      title: constants.gridNames.TrailersGrid,
      keyColumn: "trailerId",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        lockPinned: true,
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Trailer #",
          headerTooltip: "Trailer #",
          field: "trailerNumber",
          pinned: "left",
          width: constants.columnWidth.DISPATCH_TRAILER,
          minWidth: constants.columnWidth.DISPATCH_TRAILER,
          cellClass: "gridCell-leftAlign gridCell-lightgreen",
          lockPosition: true,
          filterFramework: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          cellRendererFramework: GridConfig.TrailerNumberRenderer,
        },
        {
          headerName: "Trailer Name",
          headerTooltip: "Trailer Name",
          field: "trailerName",
          filterFramework: MultiSelectFilter,
          width: constants.columnWidth.DISPATCH_TRAILER_STATUS,
          minWidth: constants.columnWidth.DISPATCH_TRAILER_TYPE,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Class",
          headerTooltip: "Trailer Class",
          field: "class",
          filterFramework: MultiSelectFilter,
          width: constants.columnWidth.DISPATCH_TRAILER_CLASS,
          minWidth: constants.columnWidth.DISPATCH_TRAILER_CLASS,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Trailer Status",
          headerTooltip: "Trailer Status",
          field: "trailerStatus",
          filterFramework: MultiSelectFilter,
          width: constants.columnWidth.DISPATCH_TRAILER_STATUS,
          minWidth: constants.columnWidth.DISPATCH_TRAILER_STATUS,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Manifest #",
          headerTooltip: "Manifest #",
          field: "manifestNumber",
          width: constants.columnWidth.DISPATCH_MANIFEST,
          minWidth: constants.columnWidth.DISPATCH_MANIFEST,
          cellRendererFramework: GridConfig.ManifestNumberRenderer,
          filterFramework: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: "Inbound Terminal",
          headerTooltip: "Inbound Terminal",
          field: "inboundTerminal",
          filterFramework: MultiSelectFilter,
          width: constants.columnWidth.DISPATCH_IBOB_TERMINAL,
          minWidth: constants.columnWidth.DISPATCH_IBOB_TERMINAL,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Outbound Terminal",
          headerTooltip: "Outbound Terminal",
          field: "outboundTerminal",
          filterFramework: MultiSelectFilter,
          width: constants.columnWidth.DISPATCH_IBOB_TERMINAL,
          minWidth: constants.columnWidth.DISPATCH_IBOB_TERMINAL,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Last Updated",
          headerTooltip: "Last Updated",
          field: "lastUpdated",
          filterFramework: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME,
          },
          minWidth: constants.columnWidth.DISPATCH_TRAILER_STATUS,
          cellClass: "gridCell-leftAlign",
          valueFormatter: formatDateTimeWithoutUTCConversion,
        },
      ],
    };
  }
}
